<template>
  <section class="s-wizard">
    <div class="s-breadcrumb-target"></div>

    <wizard-intro
      v-if="hasStartWizard"
      :data="intro"
      @start-wizard="startWizard"></wizard-intro>

    <div v-if="showQuestions">
      <Loader v-if="isLoading" display="absolute"></Loader>
      <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs" />

      <div class="s-wizard__questions">
        <div class="s-wizard__questions__conts">
          <div class="s-wizard__questions__row">
            <div class="s-wizard__questions__head">
              <h1 class="s-wizard__title">{{ wizardTitle }}</h1>
              <div class="b-wizard-steps">
                <ul v-if="stepsData">
                  <li
                    v-for="(step, index) in stepsData"
                    :key="index"
                    :class="index <= currentStep - 1 ? 'active' : ''">
                    <span>{{ index + 1 }}</span>
                    {{ step.title }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="s-wizard__questions__body-wrapper">
              <Step1
                v-if="currentStep === 1"
                :step-data="step1Questions"
                :current-step="currentStep"
                @enable-next-btn="onEnableNextBtn"
                @gather-data="getSelectedOptions" />

              <Step2
                v-if="currentStep === 2"
                :step-data="step2Questions"
                :current-step="currentStep"
                @enable-next-btn="onEnableNextBtn"
                @gather-data="getSelectedOptions" />

              <Step3
                v-if="currentStep === 3"
                :step-data="step3Questions"
                :current-step="currentStep"
                @enable-next-btn="onEnableNextBtn"
                @gather-data="getSelectedOptions" />

              <Step4
                v-if="currentStep === 4"
                :step-data="step4Questions"
                :current-step="currentStep"
                @enable-next-btn="onEnableNextBtn"
                @gather-data="getSelectedOptions" />

              <div class="s-wizard__footer">
                <div v-if="showPrev" class="s-wizard__footer__prev">
                  <button
                    type="button"
                    class="btn btn-prev"
                    @click="goToPrevStep">
                    <span>{{ dictionary.previous }}</span>
                  </button>
                </div>
                <div v-if="showNextBtn" class="s-wizard__footer__next">
                  <button
                    type="button"
                    class="btn btn-primary"
                    :disabled="nextBtnIsDisabled"
                    @click="clickedContinueBtn">
                    <span>{{ dictionary.next }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <wizard-results v-if="showResults" :results="results"></wizard-results>
  </section>
</template>

<script>
import axios from 'axios'
import Loader from '../components/common/Loader.vue'
import Alert from '../components/common/Alert.vue'
import WizardIntro from '../components/wizard/WizardIntro.vue'
import WizardResults from '../components/wizard/WizardResults.vue'
import Step1 from '../components/wizard/WizardStep1.vue'
import Step2 from '../components/wizard/WizardStep2.vue'
import Step3 from '../components/wizard/WizardStep3.vue'
import Step4 from '../components/wizard/WizardStep4.vue'

import * as lib from '../../lib/lib'
import $ from 'jQuery'

// import { v4 as uuidv4 } from 'uuid'

export default {
  components: {
    Loader,
    Alert,
    Step1,
    Step2,
    Step3,
    Step4,
    WizardIntro,
    WizardResults,
  },

  data() {
    return {
      // default
      isLoading: false,
      errorMsgs: [],
      results: [],
      intro: {},
      stepsData: [],
      step1Questions: [],
      step2Questions: [],
      step3Questions: [],
      step4Questions: [],
      wizardTitle: '',
      hasStartWizard: true,
      showResults: false,
      allAnswers: null,

      currentStep: 1,
      nextBtnIsDisabled: true,
    }
  },
  computed: {
    showQuestions() {
      return (
        this.stepsData &&
        this.stepsData.length &&
        !this.hasStartWizard &&
        !this.showResults
      )
    },
    showNextBtn() {
      return this.currentStep <= this.stepsData.length ? true : false
    },
    showPrev() {
      return this.currentStep > 1 ? true : false
    },
  },
  mounted() {
    const {
      intro,
      steps,
      wizardTitle,
      step1Questions,
      step2Questions,
      step3Questions,
      step4Questions,
    } = lib.getData('wizardDataNew')
    this.intro = intro
    this.stepsData = steps
    this.step1Questions = step1Questions
    this.step2Questions = step2Questions
    this.step3Questions = step3Questions
    this.step4Questions = step4Questions
    this.wizardTitle = wizardTitle
  },

  methods: {
    startWizard() {
      this.hasStartWizard = !this.hasStartWizard
      lib.scrollToElem($('.s-wizard'))
    },

    goToNextStep() {
      this.currentStep += 1
      this.nextBtnIsDisabled = true
      lib.scrollToElem($('.s-wizard'))
    },
    goToPrevStep() {
      this.currentStep -= 1
      lib.scrollToElem($('.s-wizard'))
    },

    onEnableNextBtn(value) {
      this.nextBtnIsDisabled = !value
    },

    clickedContinueBtn() {
      if (this.currentStep < this.stepsData.length) {
        this.goToNextStep()
      } else {
        lib.scrollToTop()
        this.getResults()
      }
    },

    answerExist(questionId) {
      if (!this.allAnswers.answers) {
        return false
      }

      return this.allAnswers.answers.find(
        (item) => item.questionId === questionId
      )
    },

    getSelectedOptions(newObject) {
      if (this.allAnswers === null || this.allAnswers === undefined) {
        this.allAnswers = newObject
      }

      if (this.currentStep > 1) {
        if (this.answerExist(newObject.questionId)) {
          this.allAnswers.answers.find((item) => {
            if (item.questionId === newObject.questionId) {
              item.answerIds = newObject.answerIds
            }
          })
        } else if (this.allAnswers.answers) {
          // this.allAnswers.answers = [...this.allAnswers.answers, newObject]
          this.allAnswers.answers.push(newObject)
        } else {
          this.allAnswers.answers = [newObject]
        }
      }

      // console.log('All Answers', this.allAnswers)
    },

    async callCaptcha() {
      /* eslint-disable no-undef */

      return new Promise((resolve, reject) => {
        const fetchAsyncData = async () => {
          try {
            const result = await grecaptcha.execute(
              this.configuration.reCaptchaPublicKey,
              {
                action: this.configuration.action,
              }
            )
            resolve(result)
          } catch (error) {
            reject(error)
          }
        }

        fetchAsyncData()
      })

      /* eslint-enable no-alert, no-console */
    },

    async getResults() {
      this.isLoading = true

      const captchaToken = await this.callCaptcha()

      const postData = {
        ...this.allAnswers,
        captchaTokenResponse: captchaToken,
        sessionId: this.configuration.sessionId,
      }

      if (!captchaToken) return

      axios
        .post(this.configuration.endpointWizardResultsData, postData, {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
        .then((response) => {
          const { hasError, errorMessages, data } = response.data
          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }
          this.results = data

          this.$nextTick(() => {
            this.handleSuccess()
            this.showResults = true
          })
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },
    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },
  },
}
</script>
